"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const styles_1 = require("../styles");
const StyledFunctions_1 = require("../helpers/StyledFunctions");
const __1 = require("..");
const defaultProps = {};
const Container = (0, styled_components_1.default)(__1.Flex) `
  border: 1px solid ${styles_1.Colors.Border};
  border-radius: 3px;
`;
const Page = (0, styled_components_1.default)(__1.Flex) `
  padding: 0.5rem;
  cursor: pointer;
  font-weight: bold;
  color: ${props => (props.isSelected ? styles_1.Colors.Primary : styles_1.Colors.Dark)};
  text-decoration: ${props => (props.isSelected ? 'underline' : 'none')};
  &:hover {
    color: ${styles_1.Colors.Primary};
  }
`;
const Pagination = ({ total, page, onGoTo, ...restProps }) => {
    const { margins } = (0, StyledFunctions_1.extractMarginAndPadding)(restProps);
    return (react_1.default.createElement(Container, { ...margins },
        page - 1 > 0 && (react_1.default.createElement(Page, { onClick: () => {
                onGoTo(page - 1);
            } }, "Previous")),
        Array.from({ length: total }).map((_, index) => {
            const isSelected = page === index + 1;
            if (index === 0) {
                return (react_1.default.createElement(Page, { key: "first-page", isSelected: isSelected, onClick: () => {
                        if (page !== 1) {
                            onGoTo(1);
                        }
                    } }, "1"));
            }
            if (index + 1 === total) {
                return (react_1.default.createElement(Page, { key: "last-page", isSelected: isSelected, onClick: () => {
                        if (page !== total) {
                            onGoTo(total);
                        }
                    } }, total));
            }
            if (index !== 0 && index + 1 === page - 2) {
                return react_1.default.createElement(Page, { key: "first-middle" }, "...");
            }
            if (index !== 0 && index + 1 === page + 2) {
                return react_1.default.createElement(Page, { key: "last-middle" }, "...");
            }
            if (index !== 0 && (isSelected || index + 1 === page - 1 || index + 1 === page + 1)) {
                return (react_1.default.createElement(Page, { key: `page-${index}`, isSelected: isSelected, onClick: () => {
                        if (page !== index + 1) {
                            onGoTo(index + 1);
                        }
                    } }, index + 1));
            }
            return null;
        }),
        page < total && (react_1.default.createElement(Page, { onClick: () => {
                if (page + 1 <= total) {
                    onGoTo(page + 1);
                }
            } }, "Next"))));
};
Pagination.defaultProps = defaultProps;
exports.default = Pagination;
